import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangHiIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "b",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 18,
				height: 18,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
					fill: "#fff"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#b)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M-4.527 0h27.054v18.036H-4.527V0Z",
					fill: "#F89939"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "c",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 18,
				height: 18,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
					fill: "#fff"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#c)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M-4.527 6.012h27.054v6.012H-4.527V6.012Z",
					fill: "#fff"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "d",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 18,
				height: 18,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
					fill: "#fff"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#d)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M-4.527 12.024h27.054v6.012H-4.527v-6.012Z",
					fill: "#1E8943"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "e",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 18,
				height: 18,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
					fill: "#fff"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#e)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M9 11.423a2.405 2.405 0 1 0 0-4.81 2.405 2.405 0 0 0 0 4.81Z",
					fill: "#2A2C7A"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "f",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 18,
				height: 18,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
					fill: "#fff"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#f)",
				fill: "#fff",
				children: [/* @__PURE__ */ _jsx("path", { d: "M10.603 7.656a2.102 2.102 0 0 0-.115-.126l-.842.944-.334.263a.419.419 0 0 1 .04.052l.34-.254 1.13-.569a2.095 2.095 0 0 0-.091-.144.105.105 0 0 1-.128-.166Zm-1.863-.62a.105.105 0 0 1-.118-.087c-.113.02-.223.05-.33.087a.105.105 0 0 1-.193.08 2.096 2.096 0 0 0-.151.08l.694 1.057.167.39a.46.46 0 0 1 .061-.025l-.158-.394-.257-1.238.397 1.2.06.42a.42.42 0 0 1 .066-.008l-.05-.421L9 6.914a2.13 2.13 0 0 0-.17.008.105.105 0 0 1-.09.114Z" }), /* @__PURE__ */ _jsx("path", { d: "M10.217 7.432a.105.105 0 0 1-.021-.145 2.08 2.08 0 0 0-.144-.09l-.569 1.128-.254.34a.423.423 0 0 1 .052.041l.263-.334.944-.842a2.09 2.09 0 0 0-.126-.115.105.105 0 0 1-.145.017Zm-.673 2.232-.262-.334a.42.42 0 0 1-.053.041l.254.34.57 1.129c.048-.028.096-.059.143-.091a.105.105 0 0 1 .166-.128c.044-.037.086-.075.126-.115l-.944-.842Zm.298-.574-.422-.05a.421.421 0 0 1-.008.066l.42.06 1.2.397-1.238-.257-.394-.158a.415.415 0 0 1-.025.062l.39.167 1.057.693c.029-.049.055-.099.08-.15a.105.105 0 0 1 .08-.194c.038-.106.067-.216.088-.33a.105.105 0 0 1 .027-.207 2.13 2.13 0 0 0 .007-.17l-1.262.072Zm1.14-.333a.105.105 0 0 1 .088-.118 2.089 2.089 0 0 0-.088-.329.105.105 0 0 1-.08-.194 2.115 2.115 0 0 0-.08-.15l-1.057.693-.39.167c.01.02.018.04.025.062l.394-.158 1.239-.257-1.201.397-.42.06a.421.421 0 0 1 .008.066l.422-.05 1.262.072c0-.058-.003-.114-.007-.17a.105.105 0 0 1-.115-.091Zm-1.289.745-.34-.255a.422.422 0 0 1-.041.053l.334.263.842.943c.04-.04.078-.082.115-.125a.105.105 0 0 1 .128-.167c.032-.046.063-.094.091-.144l-1.13-.568Zm-.672-.904a.424.424 0 0 1 .067.009l.06-.42.397-1.201-.258 1.238-.157.394a.418.418 0 0 1 .061.026l.167-.39.694-1.058a2.092 2.092 0 0 0-.15-.08.105.105 0 0 1-.195-.08 2.088 2.088 0 0 0-.329-.087.105.105 0 0 1-.208-.027A2.13 2.13 0 0 0 9 6.914l.072 1.263-.05.421Zm-.565-.226.262.334a.42.42 0 0 1 .053-.04l-.254-.34-.57-1.13c-.048.029-.096.06-.143.091a.105.105 0 0 1-.166.128 2.109 2.109 0 0 0-.126.115l.944.842Zm-.149.163.34.254a.421.421 0 0 1 .041-.052l-.334-.263-.842-.944a2.29 2.29 0 0 0-.115.126.105.105 0 0 1-.128.166 2.102 2.102 0 0 0-.091.144l1.13.569Zm.671.903a.422.422 0 0 1-.066-.008l-.06.42-.397 1.2.257-1.238.158-.394a.418.418 0 0 1-.061-.025l-.167.39-.694 1.057c.05.028.1.055.15.08a.105.105 0 0 1 .195.08c.106.038.216.067.329.088a.105.105 0 0 1 .208.027c.056.004.113.007.17.007L8.928 9.86l.05-.422Zm-1.03 1.402.569-1.13.254-.339a.422.422 0 0 1-.053-.04l-.262.333-.944.842c.04.04.083.078.126.115a.105.105 0 0 1 .166.128c.047.032.095.063.144.091ZM9.26 11a.105.105 0 0 1 .118.088 2.1 2.1 0 0 0 .33-.088.105.105 0 0 1 .193-.08c.052-.025.102-.052.15-.08l-.693-1.057-.167-.39a.418.418 0 0 1-.061.025l.157.394.258 1.239-.397-1.201-.06-.42a.422.422 0 0 1-.067.008l.051.422L9 11.122c.057 0 .114-.003.17-.007A.105.105 0 0 1 9.26 11ZM7.098 9.92c.025.051.051.101.08.15l1.057-.693.39-.167a.421.421 0 0 1-.025-.062l-.394.158-1.239.257 1.201-.396.42-.06a.42.42 0 0 1-.008-.067l-.422.05-1.262-.071c0 .057.003.114.007.17a.105.105 0 0 1 .027.208c.02.113.05.223.088.329a.105.105 0 0 1 .08.194Zm1.59-.62a.42.42 0 0 1-.041-.053l-.34.255-1.129.568c.028.05.059.098.091.144a.105.105 0 0 1 .128.167c.037.043.075.085.115.125l.842-.943.334-.263Zm-.108-.303a.424.424 0 0 1 .008-.066l-.42-.06-1.2-.397 1.238.257.394.158a.418.418 0 0 1 .025-.062l-.39-.167-1.057-.693a2.685 2.685 0 0 0-.08.15.105.105 0 0 1-.08.194 2.088 2.088 0 0 0-.088.33.105.105 0 0 1-.027.207 2.13 2.13 0 0 0-.007.17l1.262-.071.422.05Z" })]
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h18v18H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLangHiIconmin);
export { ForwardRef as ReactComponent };
